import React from 'react';

const Header = ({ imageData }) => {
    return (
        <header className="navbar navbar-sticky navbar-expand-lg navbar-dark">
            <div className="container position-relative">
                <a className="navbar-brand" href="/">
                    <img className="navbar-brand-regular" src="/img/mobicloud-logo.png" alt="MobiCloud" style={{height: '40px'}} />
                    <img className="navbar-brand-sticky" src="/img/mobicloud-logo.png" alt="MobiCloud" style={{height: '40px'}} />
                </a>
                <button className="navbar-toggler d-lg-none" type="button" data-toggle="navbarToggler" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="navbar-inner">
                    {/* Mobile Menu Toggler */}
                    <button className="navbar-toggler d-lg-none" type="button" data-toggle="navbarToggler" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <nav>
                        <ul className="navbar-nav" id="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link scroll" href="#home">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll" href="#services">Services</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll" href="#products">Products</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll" href="#about">About</a>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link scroll" href="#team">Team</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll" href="#pricing">Pricing</a>
                            </li> */}
                            <li className="nav-item">
                                <a className="nav-link scroll" href="#contact">Contact</a>
                            </li>
                        </ul>
                    </nav>
                    {/* Header Action - Removed redundant Get Started button */}
                    {/* <div className="navbar-actions d-flex align-items-center">
                        <a className="btn btn-primary btn-sm" href="#contact">Get Started</a>
                    </div> */}
                </div>
            </div>
        </header>
    );
};

export default Header; 